export default __webpack_public_path__ + "static/media/ail3.a1e24f01.svg";